import React, { useEffect, useState } from "react";
import "./GetMobileApp.scss";
import appLogo from "../assets/images/pictures/app-logo.png";
import { getMobileOSIfWeb } from "../utils/helpers";
import { MOBILE_APP_URLS } from "../constants/constants";
import { useScrollLock } from "../hooks/useScrollLock";
import { useLocation } from "react-router-dom";

const APP_POPUP_IGNORE_KEY = "appPopupIgnoredAt";
const IGNORE_DURATION_MS = 10 * 60 * 1000;
const POPUP_DELAY_MS = 3000;

const GetMobileApp: React.FC = () => {
    const [appURL, setAppURL] = useState<string | null>(null);
    const [visible, setVisible] = useState(false);
    const location = useLocation();

    const {lockScroll, unlockScroll} = useScrollLock();

    useEffect(() => {
        if(visible){
            lockScroll();
        }

        return () => {
            unlockScroll();
        }
    }, [visible])

    useEffect(() => {
        const userMobileOS = getMobileOSIfWeb();
        if (!userMobileOS) return;

        const ignoredAt = localStorage.getItem(APP_POPUP_IGNORE_KEY);

        if (ignoredAt) {
            const ignoredTime = Number(ignoredAt);
            if (!Number.isNaN(ignoredTime)) {
                const diff = Date.now() - ignoredTime;
                if (diff < IGNORE_DURATION_MS) return;
            }
        }

        if (userMobileOS === "android") {
            showPopup(MOBILE_APP_URLS.android);
        } else if (userMobileOS === "ios") {
            showPopup(MOBILE_APP_URLS.ios);
        }
    }, [location]);

    const showPopup = (url: string) => {
        setTimeout(() => {
            setAppURL(url);
            requestAnimationFrame(() => setVisible(true));
        }, POPUP_DELAY_MS);
    };

    const handleClose = () => {
        localStorage.setItem(APP_POPUP_IGNORE_KEY, Date.now().toString());
        setVisible(false);

        setTimeout(() => {
            setAppURL(null);
        }, 300);
    };

    if (!appURL) return null;

    return (
        <div
            id="ad-timed-2"
            className={`menu menu-box-modal menu-box-detached menu-active app-modal ${
                visible ? "app-modal--visible" : ""
            }`}
            data-menu-width="cover"
            data-menu-height="cover"
            data-menu-effect="menu-over"
            style={{ display: "block", width: "100%", height: "100%" }}
        >
            <div className="card mb-0 full-screen">
                <div className="card-top">
                    <button
                        type="button"
                        className="close-menu ad-time-close"
                        onClick={handleClose}
                        aria-label="Close"
                    >
                        <i className="fa fa-times" />
                    </button>
                </div>

                <div className="card-center h-100 mx-4 d-flex flex-column justify-content-between py-5">
                    <div className="text-center mt-5">
                        <div
                            className="app-logo mx-auto mb-3 mt-5"
                            style={{
                                backgroundImage: `url(${appLogo})`,
                                backgroundPosition: "center",
                                backgroundSize: "cover",
                            }}
                        />
                        <div className="app-name">INFLUNS</div>
                    </div>

                    <a
                        href={appURL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="close-menu mt-5 btn w-100 btn-m btn-center-l rounded-m shadow-xl text-uppercase font-900 btn-primary get-app-btn"
                    >
                        Get the App
                    </a>
                </div>

                <div className="card-overlay bg-white opacity-90" />
            </div>
        </div>
    );
};

export default GetMobileApp;
